import { defaultApi } from '@/plugins/api/defaultApi'
import qs from 'query-string'

export default {
  name: 'evaluation',
  namespaced: true,
  state: {
    evaluation: null,
  },
  getters: {
    isExpire(state, getters) {
      return getters.isCreditExpire || getters.isEvaluationExpire
    },
    isCreditExpire(state) {
      if (!state) {
        return false
      }
      const { evaluation } = state
      return !(evaluation.isQualified === true && evaluation.isEvaluationExpired === false)
    },
    isEvaluationExpire(state) {
      if (!state) {
        return false
      }
      const { evaluation } = state
      return evaluation.isEvaluationExpired
    },
  },
  mutations: {
    setEvaluation(state, evaluation) {
      state.evaluation = evaluation
    },
  },
  actions: {
    async getCreditEvaluationsCurrent({ commit }) {
      const { data } = await defaultApi.getCreditEvaluationsCurrent()
      commit('setEvaluation', data)
      return data
    },
    async getCreditEvaluationsUrl({}) {
      const { data } = await defaultApi.postCreditEvaluations()
      return data
    },
    async getCreditEvaluate({}, { uuid }) {
      const { data } = await defaultApi.postCreditEvaluateDetail(uuid)
      return data
    },
    async addCreditEvaluations({}, query) {
      const { data } = await defaultApi.postCreditEvaluations()
      let returnUrl = `${location.origin}/factoring/evaluation?evid=${data.uuid}`
      if (query) {
        returnUrl += `&${qs.stringify(query)}`
      }
      const url = `${data.kcbUrl}&RTN_URL=${encodeURIComponent(returnUrl)}`
      if (navigator.userAgent.match(/Android/i)) {
        document.location.replace(url)
      } else {
        location.href = url
      }
      return data
    },

    async isKcsAgreements({}) {
      const { data } = await defaultApi.getKcsAgreementsStatus()
      return data.allRequiredTermsAgreed
    },

    async isHometaxAccounts({}) {
      const {data} = await defaultApi.getCredentials();

      
      
      const retVal = data.some(item => item.provider === 'hometax')

      console.log('!!!!!!!!!!  getCredentials = ',retVal, data);

      return retVal;
    },

  },
}
